var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_1882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3203 0.605469C12.0977 0.230469 11.6875 0 11.25 0C10.8125 0 10.4023 0.230469 10.1797 0.605469L6.42969 6.85547C6.19922 7.24219 6.19141 7.72266 6.41406 8.11328C6.63672 8.50391 7.05078 8.74609 7.5 8.74609H15C15.4492 8.74609 15.8672 8.50391 16.0859 8.11328C16.3047 7.72266 16.3008 7.24219 16.0703 6.85547L12.3203 0.605469ZM11.25 12.1875V17.8125C11.25 18.6758 11.9492 19.375 12.8125 19.375H18.4375C19.3008 19.375 20 18.6758 20 17.8125V12.1875C20 11.3242 19.3008 10.625 18.4375 10.625H12.8125C11.9492 10.625 11.25 11.3242 11.25 12.1875ZM5 20C6.32608 20 7.59785 19.4732 8.53553 18.5355C9.47322 17.5979 10 16.3261 10 15C10 13.6739 9.47322 12.4021 8.53553 11.4645C7.59785 10.5268 6.32608 10 5 10C3.67392 10 2.40215 10.5268 1.46447 11.4645C0.526784 12.4021 0 13.6739 0 15C0 16.3261 0.526784 17.5979 1.46447 18.5355C2.40215 19.4732 3.67392 20 5 20Z",
    fill: "#262E80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.454d18cab2c312200db199d766147ff5.svg";
export { ForwardRef as ReactComponent };